var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92812 5.00001H5.5C6.05313 5.00001 6.5 5.44688 6.5 6.00001C6.5 6.55313 6.05313 7.00001 5.5 7.00001H1.5C0.946875 7.00001 0.5 6.55313 0.5 6.00001V2.00001C0.5 1.44688 0.946875 1.00001 1.5 1.00001C2.05313 1.00001 2.5 1.44688 2.5 2.00001V3.60001L3.05 3.05001C5.78437 0.315634 10.2156 0.315634 12.95 3.05001C15.6844 5.78438 15.6844 10.2156 12.95 12.95C10.2156 15.6844 5.78437 15.6844 3.05 12.95C2.65937 12.5594 2.65937 11.925 3.05 11.5344C3.44062 11.1438 4.075 11.1438 4.46562 11.5344C6.41875 13.4875 9.58438 13.4875 11.5375 11.5344C13.4906 9.58126 13.4906 6.41563 11.5375 4.46251C9.58438 2.50938 6.41875 2.50938 4.46562 4.46251L3.92812 5.00001Z",
    fill: "#654AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRotateLeft);
export default __webpack_public_path__ + "static/media/arrow-rotate-left.60474e72f93ddeb9b4ccf45754b22d63.svg";
export { ForwardRef as ReactComponent };